import styled from 'styled-components';

import { lighten, darken } from 'utils/colours';

import { Radio as AntdRadio } from 'antd';

const RadioButton = styled(AntdRadio.Button)`
    &.ant-radio-button-wrapper:hover {
        position: relative;
        color: ${({ theme }) => theme.colour.primary};
    }

    &.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
        color: ${({ theme }) => theme.colour.primary};
        border-color: ${({ theme }) => theme.colour.primary};
    }
    &.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
        background-color: ${({ theme }) => theme.colour.primary};
    }
    &.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):first-child {
        border-color: ${({ theme }) => theme.colour.primary};
    }
    &.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {
        color: ${({ theme }) => lighten(theme.colour.primary)};
        border-color: ${({ theme }) => lighten(theme.colour.primary)};
    }
    &.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover::before {
        background-color: ${({ theme }) => lighten(theme.colour.primary)};
    }
    &.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):active {
        color: ${({ theme }) => darken(theme.colour.primary)};
        border-color: ${({ theme }) => darken(theme.colour.primary)};
    }
    &.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):active::before {
        background-color: ${({ theme }) => darken(theme.colour.primary)};
    }

    /* reset disabled style to overwrite */
    &.ant-radio-button-wrapper-disabled:first-child,
    &.ant-radio-button-wrapper-disabled:hover {
        color: rgba(0, 0, 0, 0.25);
        background-color: #f5f5f5;
        border-color: #d9d9d9;
    }
    &.ant-radio-button-wrapper-disabled:first-child {
        border-left-color: #d9d9d9;
    }
    &.ant-radio-button-wrapper-disabled.ant-radio-button-wrapper-checked {
        color: #fff;
        background-color: #e6e6e6;
        border-color: #d9d9d9;
        box-shadow: none;
    }
`;

export default RadioButton;
